var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5.37369C12.4103 5.17786 12.4103 4.70484 12.75 4.50901L16.9776 2.07185C17.1438 1.97605 17.3514 1.97605 17.5176 2.07185L21.7452 4.50901C22.0849 4.70484 22.0849 5.17786 21.7452 5.37369L17.5176 7.81085C17.3514 7.90665 17.1438 7.90665 16.9776 7.81085L12.75 5.37369Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25477 5.37369C1.91508 5.17786 1.91508 4.70484 2.25477 4.50901L6.48242 2.07185C6.6486 1.97605 6.85621 1.97605 7.02239 2.07185L11.25 4.50901C11.5897 4.70484 11.5897 5.17786 11.25 5.37369L7.02239 7.81085C6.85621 7.90665 6.6486 7.90665 6.48242 7.81085L2.25477 5.37369Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 13.4406C12.4103 13.2447 12.4103 12.7717 12.75 12.5759L16.9776 10.1387C17.1438 10.0429 17.3514 10.0429 17.5176 10.1387L21.7452 12.5759C22.0849 12.7717 22.0849 13.2447 21.7452 13.4406L17.5176 15.8777C17.3514 15.9735 17.1438 15.9735 16.9776 15.8777L12.75 13.4406Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25478 13.4406C1.91508 13.2447 1.91508 12.7717 2.25478 12.5759L6.48241 10.1387C6.6486 10.0429 6.85621 10.0429 7.02239 10.1387L11.25 12.5759C11.5897 12.7717 11.5897 13.2447 11.25 13.4406L7.02239 15.8777C6.85621 15.9735 6.6486 15.9735 6.48241 15.8777L2.25478 13.4406Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74365 8.79346C7.77352 8.80884 7.80309 8.82497 7.83235 8.84183L12 11.2444L16.1677 8.84183C16.1969 8.82497 16.2265 8.80885 16.2563 8.79347L12.27 6.45405C12.1038 6.35825 11.8962 6.35825 11.73 6.45405L7.74365 8.79346Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8019 17.3907V19.0584C17.802 19.2257 17.7171 19.393 17.5471 19.491L12.27 21.9282C12.1038 22.024 11.8962 22.024 11.73 21.9282L6.45283 19.491C6.28411 19.3937 6.19918 19.2281 6.19806 19.062V17.3907C6.74289 17.534 7.33417 17.462 7.83236 17.1748L12 14.7723L16.1677 17.1748C16.6658 17.462 17.2571 17.534 17.8019 17.3907Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropbox);
export default __webpack_public_path__ + "static/media/dropbox.57ccc67f52a152bc515b8de41b2be038.svg";
export { ForwardRef as ReactComponent };